import React from 'react'
import { Icon } from '../Icon'
import { Link } from '../Link'
import { TooltipPopOver } from '../TooltipPopOver'

export type CollapseControlProps = {
  iconShow?: string
  iconHide?: string
  show: boolean
  setShow: (e: any) => void
  title?: string
  onToggleCollapse?: (isCollapse: boolean) => void
}
export const CollapseControl = ({
  show,
  setShow,
  iconShow,
  iconHide,
  title,
  onToggleCollapse,
}: CollapseControlProps) => {
  iconShow = iconShow ?? 'chevron-down'
  iconHide = iconHide ?? 'chevron-up'

  let icon = iconShow //'chevron-down'
  if (!show) {
    icon = iconHide //'chevron-up'
  }

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setShow((currentValue) => !currentValue)

    //then call the callback
    onToggleCollapse?.(!show)
  }

  return (
    <TooltipPopOver tooltipBody={title}>
      <Link onClick={onClick} aria-label={title}>
        <Icon name={icon} aria-hidden="true" />
      </Link>
    </TooltipPopOver>
  )
}
